import _ from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQualifications } from "src/API/CrewScheduleErrors";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { IAnchorSelection } from "./CrewScheduleCanvas";
import { CrewScheduleGL } from "./gl/CrewScheduleGL";

interface ICrewScheduleQualificationsProps {
  lastUpdatedCrew: number;
  crewSchedGL: CrewScheduleGL | null;
  start: () => void;
  isAnimating: boolean;
  hoveredViolation: IAnchorSelection;
  anchorEl: HTMLDivElement | null;
}

export const CrewScheduleQualifications = (props: ICrewScheduleQualificationsProps): null => {
  const { crewSchedGL, lastUpdatedCrew, start, isAnimating } = props;
  const dispatch = useDispatch();
  const crewQualifications = useSelector((state: IRootState) => state.crewSchedule.crewQualifications);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getQualificationsAction = useCallback((): void => {
    dispatch(getQualifications());
    setIsLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (crewSchedGL && isLoading && _.isEmpty(crewQualifications)) {
      getQualificationsAction();
    }
  }, [crewQualifications, crewSchedGL, getQualificationsAction, isLoading]);

  useEffect(() => {
    if (!crewSchedGL) {
      return;
    }
    setTimeout(() => {
      crewSchedGL.updateCrewQualifications(crewQualifications);
      if (!isAnimating) {
        start();
      }
    }, 0);
  }, [crewQualifications, lastUpdatedCrew, crewSchedGL, isAnimating, start]);

  return null;
};
